"use strict";
/*
 * Created on 03 22 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceStickersDashboardReportDTO_1 = require("../model/PriceStickersDashboardReportDTO");

var PriceStickersDashboardReportDTOConverter_1 = require("./PriceStickersDashboardReportDTOConverter");
/**
 * @author Jaroslav Sevcik
 */


var PriceStickersDashboardReportDTOConverterImpl =
/*#__PURE__*/
function (_PriceStickersDashboa) {
  _inherits(PriceStickersDashboardReportDTOConverterImpl, _PriceStickersDashboa);

  function PriceStickersDashboardReportDTOConverterImpl() {
    _classCallCheck(this, PriceStickersDashboardReportDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceStickersDashboardReportDTOConverterImpl).apply(this, arguments));
  }

  _createClass(PriceStickersDashboardReportDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PriceStickersDashboardReportDTO_1.PriceStickersDashboardReportDTO(PriceStickersDashboardReportDTO_1.PriceStickersDashboardReportDTO.schema.currentWeekRepricingCount.valueOf(source.currentWeekRepricingCount), PriceStickersDashboardReportDTO_1.PriceStickersDashboardReportDTO.schema.lastYearSameWeekRepricingCount.valueOf(source.lastYearSameWeekRepricingCount), PriceStickersDashboardReportDTO_1.PriceStickersDashboardReportDTO.schema.nextWeekRepricingCount.valueOf(source.nextWeekRepricingCount), PriceStickersDashboardReportDTO_1.PriceStickersDashboardReportDTO.schema.lastYearNextWeekRepricingCount.valueOf(source.lastYearNextWeekRepricingCount));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        currentWeekRepricingCount: source.currentWeekRepricingCount,
        lastYearSameWeekRepricingCount: source.lastYearSameWeekRepricingCount,
        nextWeekRepricingCount: source.nextWeekRepricingCount,
        lastYearNextWeekRepricingCount: source.lastYearNextWeekRepricingCount
      };
    }
  }]);

  return PriceStickersDashboardReportDTOConverterImpl;
}(PriceStickersDashboardReportDTOConverter_1.PriceStickersDashboardReportDTOConverter);

exports.PriceStickersDashboardReportDTOConverterImpl = PriceStickersDashboardReportDTOConverterImpl;